import { Injectable } from "@angular/core";

@Injectable()
export class ImageService {
  constructor() {}

  rotateImage(
    img: HTMLImageElement,
    angleAsFraction: number,
    doc: Document,
    rotateDoneHandler: (blob: Blob) => void,
    debugCanvas?: HTMLCanvasElement
  ) {
    let canvas = debugCanvas || doc.createElement("canvas");
    let ctx = canvas.getContext("2d");

    const tilted = angleAsFraction % 0.5 !== 0;

    ctx.save();
    canvas.width = tilted ? img.height : img.width;
    canvas.height = tilted ? img.width : img.height;

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(angleAsFraction * 2 * Math.PI);

    ctx.drawImage(img, -img.width / 2, -img.height / 2);

    canvas.toBlob((blob) => rotateDoneHandler(blob));

    ctx.restore();
  }

  flipImage(
    img: HTMLImageElement,
    horizontal: boolean,
    doc: Document,
    flipDoneHandler: (blob: Blob) => void,
    debugCanvas?: HTMLCanvasElement
  ) {
    let canvas = debugCanvas || doc.createElement("canvas");
    let ctx = canvas.getContext("2d");

    ctx.save();

    canvas.width = img.width;
    canvas.height = img.height;

    if (horizontal) {
      ctx.translate(0, canvas.height);
      ctx.scale(1, -1);
    } else {
      ctx.translate(canvas.width, 0);
      ctx.scale(-1, 1);
    }

    ctx.drawImage(img, 0, 0);

    canvas.toBlob((blob) => flipDoneHandler(blob));

    ctx.restore();
  }

  loadImg(
    img: HTMLImageElement,
    src: File | string,
    canvas: HTMLCanvasElement,
    imageLoadedHandler?: () => void
  ) {
    var url = "";
    if (src instanceof Blob) url = URL.createObjectURL(src);
    else url = src;

    let ctx = canvas.getContext("2d");

    img.onload = () => {
      this.drawImage(img, canvas, ctx);
      if (imageLoadedHandler) imageLoadedHandler();
      if (src instanceof Blob) URL.revokeObjectURL(url);
    };

    img.src = "";
    img.src = url;
  }

  drawImage(
    img: HTMLImageElement,
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D
  ) {
    canvas.width = img.width;
    canvas.height = img.height;

    ctx.drawImage(
      img,
      0,
      0,
      img.width,
      img.height,
      0,
      0,
      canvas.width,
      canvas.height
    );
  }
  resizeTo(
    url: string,
    maxSizeInKb: number,
    document: HTMLDocument,
    onResizedHandler: (url: string) => void
  ): void {
    let canvas: HTMLCanvasElement = document.createElement("canvas");
    let img: HTMLImageElement = document.createElement("img");

    // for debugging resize
    // document.documentElement.appendChild(img).className = "debug";
    // document.documentElement.appendChild(canvas).className = "debug";
    // uncomment the debug class in styles.scss also

    let ctx = canvas.getContext("2d");

    this.loadImage(img, url, canvas, () => {
      canvas.width = img.width;
      canvas.height = img.height;
      this.drawImage(img, canvas, ctx);

      this.resize(canvas, ctx, img, maxSizeInKb, onResizedHandler);
    });
  }
  loadImage(
    img: HTMLImageElement,
    urlToLoad: string,
    canvas: HTMLCanvasElement,
    imageLoadedHandler?: () => void
  ) {
    let ctx = canvas.getContext("2d");
    let that = this;
    let uri = urlToLoad;
    let callback = imageLoadedHandler;

    img.onload = function () {
      that.drawImage(img, canvas, ctx);
      if (callback) callback();
    };

    img.src = urlToLoad;
  }

  private resize(
    canvas: HTMLCanvasElement,
    ctx: CanvasRenderingContext2D,
    img: HTMLImageElement,
    maxSizeInKb: number,
    onResizedHandler: (url: string) => void
  ) {
    canvas.toBlob(
      (blob: Blob) => {
        if (blob.size <= maxSizeInKb * 1024) {
          let result = canvas.toDataURL("image/jpeg", 0.75);

          onResizedHandler(result);
        } else {
          canvas.width *= 0.95;
          canvas.height *= 0.95;

          ctx.drawImage(
            img,
            0,
            0,
            img.width,
            img.height,
            0,
            0,
            canvas.width,
            canvas.height
          );

          this.resize(canvas, ctx, img, maxSizeInKb, onResizedHandler);
        }
      },
      "image/jpeg",
      0.75
    );
  }
}
